import { queryOptions, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";

import type { QueryConfig } from "@/lib/react-query";
import type { PaymentData } from "@/types/payments";

type UseAllPaymentsOptions = {
  queryConfig?: QueryConfig<typeof getAllPayments>;
};

export const getAllPayments = async (): Promise<PaymentData[]> => {
  const result = await (api.get("/carburate/billing/invoices/") as Promise<{
    results: PaymentData[];
  }>);
  return Array.isArray(result?.results) ? result.results : [];
};

export const getAllPaymentsQueryOptions = () =>
  queryOptions({
    queryKey: ["payments"] as const,
    queryFn: getAllPayments,
  });

export const useAllPayments = ({ queryConfig }: UseAllPaymentsOptions = {}) => {
  return useQuery<PaymentData[], Error, PaymentData[], readonly ["payments"]>({
    enabled: hasAccessToken(),
    ...getAllPaymentsQueryOptions(),
    refetchOnWindowFocus: true,
    ...queryConfig,
  });
};
